import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactFormSection from '../../components/contact/ContactFormSection';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.target as HTMLFormElement;
      const formDataToSend = new URLSearchParams();
      
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('company', formData.company);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);

      const response = await fetch('FORM_SUBMIT_URL_PLACEHOLDER', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          subject: '',
          message: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const offices = [
    {
      city: 'Maputo',
      country: 'Mozambique',
      address: '1250 Avenida Julius Nyerere, Maputo 1100',
      phone: '+258 21 123 4567',
      email: 'maputo@alphadenexploration.com',
      type: 'Headquarters',
    },
    {
      city: 'Luanda',
      country: 'Angola',
      address: '45 Rua Rainha Ginga, Luanda',
      phone: '+244 222 123 456',
      email: 'luanda@alphadenexploration.com',
      type: 'Regional Office',
    },
    {
      city: 'Nairobi',
      country: 'Kenya',
      address: '12th Floor, Westlands Tower, Nairobi',
      phone: '+254 20 123 4567',
      email: 'nairobi@alphadenexploration.com',
      type: 'Regional Office',
    },
    {
      city: 'Lagos',
      country: 'Nigeria',
      address: '23 Adeola Odeku Street, Victoria Island, Lagos',
      phone: '+234 1 123 4567',
      email: 'lagos@alphadenexploration.com',
      type: 'Regional Office',
    },
  ];

  const contactReasons = [
    {
      icon: 'ri-handshake-line',
      title: 'Partnership Opportunities',
      description: 'Explore joint ventures and strategic partnerships',
    },
    {
      icon: 'ri-funds-line',
      title: 'Investment Inquiries',
      description: 'Learn about investment opportunities in our projects',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Development',
      description: 'Discuss supply chain and service provider opportunities',
    },
    {
      icon: 'ri-newspaper-line',
      title: 'Media & Press',
      description: 'Press inquiries and media relations',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section
        className="relative text-white overflow-hidden  h-[400px] flex items-end lg:pb-[70px] pb-0 lg:pl-[140px] pl-[0px] items-center lg:items-end lg:justify-start justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(90deg, #022843 0%, rgba(2, 40, 67, 0) 100%), url('https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770056664/b517b305ed756a2a6e006ffd1d8b5a500a69ca3a_pv7giv.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="relative z-10   flex-shrink-0">
          <h1 className="text-3xl lg:text-[50px] font-medium mb-[10px] text-white leading-tight">Contact us</h1>
        </div>
      </section>

        <ContactFormSection/>
      <Footer />
    </div>
  );
}